module.exports = __webpack_public_path__ + "img/icon-warning-vind-3.d9b7fe3b.svg";